import { useEffect } from 'react';
import { Routes } from '../routes';
import { replaceWorkspace } from '../../utils/route-utils';
import { useLocation, useNavigate } from 'react-router';
import localStorageUtils, { STORAGE_KEYS } from '../../utils/localStorageUtils';
import WorkspaceUtils from '../../utils/workspace-utils';

/*
  This components make sure you end up in a workspace route.
  For example.
  If a the URL is /app or /app/, this component will send you to /app/repo/prod/home or what ever
  ACL workspace provides you
*/

const useRedirectToDashboardIfNeeded = (hasFinishedInitializing: boolean) => {
  // Use localStorage directly for initialization (don't depend on context)
  const storedWorkspace = localStorageUtils.getItem(STORAGE_KEYS.MOST_RECENTLY_VIEWED_WORKSPACE);
  const workspace = storedWorkspace || WorkspaceUtils.getDefaultWorkspace();

  const location = useLocation();
  const navigate = useNavigate();
  const noWorkspacePath = `/repo/false/home`;
  const defaultPublicFreeTrialWorkspacePath = `/repo/prod/home`;

  useEffect(() => {
    if (hasFinishedInitializing) {
      if (location && location.pathname === '/') {
        const pathName = replaceWorkspace(Routes.dashboard, workspace);
        navigate(pathName);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFinishedInitializing, workspace]);
};

export default useRedirectToDashboardIfNeeded;
